var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendarIcon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 1.45837C7.01184 1.45837 7.29167 1.7382 7.29167 2.08337V2.70837L12.7083 2.70837V2.08337C12.7083 1.7382 12.9882 1.45837 13.3333 1.45837C13.6785 1.45837 13.9583 1.7382 13.9583 2.08337V2.70837H14.1667C16.3528 2.70837 18.125 4.48058 18.125 6.66671V14.5834C18.125 16.7695 16.3528 18.5417 14.1667 18.5417H5.83333C3.64721 18.5417 1.875 16.7695 1.875 14.5834L1.875 6.66671C1.875 4.48058 3.64721 2.70837 5.83333 2.70837H6.04167V2.08337C6.04167 1.7382 6.32149 1.45837 6.66667 1.45837ZM6.04167 3.95837H5.83333C4.33756 3.95837 3.125 5.17094 3.125 6.66671L3.125 7.29171L16.875 7.29171V6.66671C16.875 5.17094 15.6624 3.95837 14.1667 3.95837H13.9583V4.58337C13.9583 4.92855 13.6785 5.20837 13.3333 5.20837C12.9882 5.20837 12.7083 4.92855 12.7083 4.58337V3.95837H7.29167V4.58337C7.29167 4.92855 7.01184 5.20837 6.66667 5.20837C6.32149 5.20837 6.04167 4.92855 6.04167 4.58337V3.95837ZM16.875 8.54171H3.125L3.125 14.5834C3.125 16.0791 4.33756 17.2917 5.83333 17.2917H14.1667C15.6624 17.2917 16.875 16.0791 16.875 14.5834V8.54171Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1c5d0310eebc8014f08903ba35fa7204.svg";
export { ForwardRef as ReactComponent };